
































import BaseLoading from '@/components/base/BaseLoading.vue';
import BasePaginatorHoc from '@/components/base/BasePaginatorHoc.vue';
import { Breadcrumb } from '@/components/BreadCrumbs.vue';
import ContentWrapper from '@/components/ContentWrapper.vue';
import { Vue, Component } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import CourseList from './DashboardOverview/components/CourseList.vue';
import CourseSearch from './DashboardOverview/CourseSearch.vue';
import {
  CourseFilterOptions,
  CourseListItem,
  CourseTypeDTO,
  FilteredCoursePayload,
  GetCoursesResponsePayload,
  initialFilterState
} from '@/store/modules/jtms/course/course.types';
import { RootState } from '@/store/store';
import { Pagination } from '@/store/modules/admin/types/admin.types';
import { SortOrder } from '@/jbi-shared/types/search.types';
import { CourseSortColumns, CourseStatus } from '@/jbi-shared/types/jtms.types';
import { PaginatorSpecs, SortEventData } from '@/store/types/general.types';

@Component({
  components: {
    ContentWrapper,
    BaseLoading,
    CourseSearch,
    CourseList,
    BasePaginatorHoc
  }
})
export default class ViewCoursesByStatus extends Vue {
  pageHeader: string = '';
  courseCount: number = 0;

  perPage = 50;
  page = 1;
  sortColumn: string = CourseSortColumns.NAME;
  sortOrder: SortOrder = SortOrder.ASC;

  courseFilterParams: CourseFilterOptions = { ...initialFilterState };
  queryParamsForCourses: FilteredCoursePayload = {
    ...this.courseFilterParams,
    limit: 50,
    page: 1,
    sortColumn: CourseSortColumns.NAME,
    sortOrder: SortOrder.ASC
  };

  @Action('course/getCourseTypes')
  getCourseTypes!: () => Promise<CourseTypeDTO[]>;

  @Action('course/getCourses')
  getCourses!: (
    options: FilteredCoursePayload
  ) => Promise<GetCoursesResponsePayload>;

  @State((state: RootState) => state.course.courseTypes)
  courseTypes!: CourseTypeDTO[];

  @State(({ course }: RootState) => course.courses)
  courses!: Pagination<CourseListItem[]>;

  get CourseList() {
    return CourseList;
  }

  get breadcrumbs(): Breadcrumb[] {
    const root: Breadcrumb = {
      route: {
        name: 'dashboard-overview'
      },
      text: 'Dashboard'
    };
    const current: Breadcrumb = {
      text: `${this.pageHeader} Courses`
    };
    return [root, current];
  }

  created() {
    this.getCourseListWithCorrectStatusParams();
  }

  mounted() {
    this.getCourseTypes();
    if (!this.$route.params.courseStatus) {
      this.$router.replace({ name: 'page-not-found' });
      return;
    }
    this.getPageHeader();
    this.getCourseCount();

    this.handleResetFilter();
  }

  getCourseListWithCorrectStatusParams() {
    const map = new Map();
    map.set('status', this.getStatusRoute());
    this.modifyQueryParams(map);
    this.refreshList();
  }

  refreshList() {
    this.getCourseList(this.queryParamsForCourses);
  }

  modifyQueryParams<T>(paramsMap: Map<string, T>) {
    for (const [key, value] of paramsMap.entries()) {
      if (key in this.queryParamsForCourses) {
        // Use type assertion to safely assign the value
        (this.queryParamsForCourses as Record<string, any>)[key] = value;
      }
    }
  }

  handleSort(data: SortEventData) {
    this.sortColumn = data.sortColumn;
    this.sortOrder = data.sortOrder;

    const map = new Map();
    map.set('sortColumn', data.sortColumn);
    map.set('sortOrder', data.sortOrder);

    this.modifyQueryParams(map);
    this.refreshList();
  }

  handleFilter() {
    const map = new Map();
    map.set('page', 1);

    // Dynamically map each course filter to the query params
    for (const [key, value] of Object.entries(this.courseFilterParams)) {
      if (key === 'endDate' && value) {
        map.set(key, new Date(value.setHours(23, 59, 59)));
      } else {
        map.set(key, value);
      }
    }

    this.modifyQueryParams(map);
    this.refreshList();
  }

  handlePaginator(paginator: PaginatorSpecs) {
    this.perPage = paginator.perPage;
    this.page = paginator.page;

    const map = new Map();
    map.set('limit', paginator.perPage);
    map.set('page', paginator.page);

    this.modifyQueryParams(map);
    this.refreshList();
  }

  getCourseList(params: FilteredCoursePayload) {
    if (
      // Placeholder for future permissions check on user
      true
    ) {
      this.getCourses(params);
    }
  }

  handleResetFilter() {
    this.courseFilterParams = {
      ...initialFilterState,
      status: this.getStatusRoute()
    };
  }

  getPageHeader() {
    switch (this.$route.params.courseStatus) {
      case 'published':
        this.pageHeader = 'Published';
        break;
      case 'in-progress':
        this.pageHeader = 'In Progress';
        break;
      case 'draft':
        this.pageHeader = 'Draft';
        break;
      case 'cancelled':
        this.pageHeader = 'Cancelled';
        break;
      case 'completed':
        this.pageHeader = 'Completed';
        break;
      default:
        // Handles any other unmatched value
        this.pageHeader = 'Published';
    }
  }

  getStatusRoute() {
    switch (this.$route.params.courseStatus) {
      case 'published':
        return CourseStatus.PUBLISHED;
      case 'in-progress':
        return CourseStatus.IN_PROGRESS;
      case 'draft':
        return CourseStatus.DRAFT;
      case 'cancelled':
        return CourseStatus.CANCELLED;
      case 'completed':
        return CourseStatus.COMPLETED;
      default:
        // Handles any other unmatched value
        return CourseStatus.PUBLISHED;
    }
  }

  getCourseCount() {
    this.courseCount = this.$route.params.count ? +this.$route.params.count : 0;
  }
}
